const config = {
    projectName: 'Condition Monitoring System',
    menuVersion: 'V2.1',
}

export {
    config,
}